import { cn } from "./_utils";
import { Label } from "./label";

type FormFieldProps = {
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  htmlFor?: string;
  className?: string;
  children: React.ReactNode;
};

/**
 * Composition wrapper that combines a Label, an input slot, and a
 * hint/error message. Error text takes precedence over hint.
 *
 * @example
 * <FormField label="Email" hint="We'll never share it." htmlFor="email">
 *   <Input id="email" />
 * </FormField>
 *
 * @example
 * <FormField label="Email" required error="Required" htmlFor="email">
 *   <Input id="email" state="error" />
 * </FormField>
 */
export function FormField({
  label,
  hint,
  error,
  required,
  htmlFor,
  className,
  children,
}: FormFieldProps) {
  return (
    <div className={cn("flex flex-col gap-xs", className)}>
      <Label htmlFor={htmlFor} required={required}>
        {label}
      </Label>
      {children}
      {error ? (
        <p className="text-sm text-error">{error}</p>
      ) : hint ? (
        <p className="text-sm text-text-tertiary">{hint}</p>
      ) : null}
    </div>
  );
}
